module.exports = __webpack_public_path__ + "img/k.e4714ec9.png";